const MIN_LENGTH = 6;

export function passwordPolicyErrors(password, t) {
  const value = password == null ? "" : String(password);
  const errors = [];

  if (value.length < MIN_LENGTH) {
    errors.push(t("login.passwordPolicy.minLength"));
  }
  if (!/[A-Z]/.test(value)) {
    errors.push(t("login.passwordPolicy.uppercase"));
  }
  if (!/[0-9]/.test(value)) {
    errors.push(t("login.passwordPolicy.number"));
  }
  if (!/[^A-Za-z0-9]/.test(value)) {
    errors.push(t("login.passwordPolicy.special"));
  }

  return errors;
}

export function passwordPolicyHint(t) {
  return t("login.passwordPolicy.hint");
}

export default {
  passwordPolicyErrors,
  passwordPolicyHint
};
